// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import PropTypes from 'prop-types'
import { TrackingProvider } from '@indeed/flex-tracking-context'

import ManagerCommissionsList from 'syft-acp-core/entities2/ManagerCommissionsList'
import PageView from 'syft-acp-core/components/PageView'
import { recordLabel, useEmployerName } from 'syft-acp-core/components/PageTitle'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'

export const ManagerCommissionsView = props => {
  const { match } = props
  const { params } = match
  const employerID = params.id ?? params.employer_id
  const employerName = useEmployerName(Number(employerID))

  return (
    <TrackingProvider
      value={{
        context: {
          employer_id: Number(params.id),
          sales_win_association_id: Number(params.sales_win_association_id),
          work_location_id: Number(params.work_location_id),
        },
      }}
    >
      <SubNavigation subPage="employers" data={{ employerID: Number(employerID) }} />
      <PageView
        title={[
          `Commission ${params.sales_win_association_id}`,
          ...(params.work_location_id ? [`Work location ${params.work_location_id}`] : []),
          recordLabel('Employer', employerID, employerName),
        ]}
        entityPage
      >
        <ManagerCommissionsList {...match} />
      </PageView>
    </TrackingProvider>
  )
}

ManagerCommissionsView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.object.isRequired,
  }),
}
